import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { authenticatedPostRequest } from '../../RestApi';
import { PricingCard } from '../PricingCard';
import ConfettiExplosion from 'react-confetti-explosion';
import { trackRedditEvent, trackGoogleEvent, trackLinkedInEvent } from '../../ad_tracking/ad_tracking';

// Parameters for the confetti popper explosion, which is _quite_ satisfying:
const largeProps = {
    force: 0.8,
    duration: 3000,
    particleCount: 300,    
    width: 3000,
    zIndex: 100,
    colors: [
        'rgb(188, 254, 135)',  
        'rgb(169, 107, 254)',  
        'rgb(57, 215, 199)',
        'rgb(18, 10, 180)'
    ]
};

const adTrackStartTrial = () => {    
    const value = 0.0;
    const currency = 'USD';
    
    trackRedditEvent('Custom', {
        customEventName: 'Start Free Trial',
        value: value,
        currency: currency,
        itemCount: 1,
        products: [{
            id: 'launch_preview',
            name: 'Preview Access',
            category: 'Subscription',
            price: value,
            quantity: 1
        }]
    });
    // This is a second less-precise event that we'll register any time someone kicks off a
    // payment-required flow. It looks like reddit's Ads graphs don't all support the more precise
    // custom event above, so this makes sure we can plot ads to billable conversions. 
    //
    // There shouldn't be any risk of duplication since these events are separately tracked. 
    trackRedditEvent('SignUp');

    trackGoogleEvent('conversion', {
        'send_to': 'AW-17124613764/vVSTCLrkns8aEIS90-U_',
        'value': 1.0,   // This is the google default value for a no-value conversion event
        'currency': currency
    });

    trackLinkedInEvent({ conversion_id: 20129676 });
}



export async function startStripeTrial(user) {

    const requestData = {
        priceId: 'stripe_launch_preview_trial_price_id',
        email: user.signInUserSession.idToken.payload.email,
        cognitoSub: user.signInUserSession.idToken.payload.sub
    };

    // Ad platforms tracking the trial signup
    adTrackStartTrial();

    const data = await authenticatedPostRequest(
        `${process.env.REACT_APP_SUBSCRIPTION_API_URL}/stripe_start_trial`,
        requestData
    );

    return data;
}


export function StartTrialCard({ 
    productName = "Preview Access",
    description = "Free for one month with no credit card required, then choose to continue for $25 per month. Cancel any time.",
    price = "FREE",
    cycle = "one month", 
    pricePreposition = "for"
}) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showConfetti, setShowConfetti] = useState(false);

    const { user } = useAuthenticator((context) => [context.user]);
    const navigate = useNavigate();
    const handleStartTrial = async () => {
        setIsLoading(true);
        setError(null);
        
        try {
            const data = await startStripeTrial(user);
            
            // Handle successful response
            console.log('Trial started successfully:', data);
            setShowConfetti(true);
            
            // Redirect after a short delay to allow confetti to show
            setTimeout(() => {
                navigate('/dashboard');
            }, 2000);
            
        } catch (error) {
            console.error('Error starting trial:', error);
            setError(error.message);
        } finally {
            // setIsLoading(false);
        }
    };

    return (
        <PricingCard
            productName={productName}
            description={description}
            price={price}
            cycle={cycle}
            onPurchase={handleStartTrial}
            isLoading={isLoading}
            error={error}
            confettiComponent={showConfetti ? <ConfettiExplosion {...largeProps}/> : null}
            pricePreposition={pricePreposition}
            buttonText="Start Trial"
        />
    );
}

export default StartTrialCard; 